import { render, staticRenderFns } from "./DesktopRemote.vue?vue&type=template&id=1f73663c&scoped=true&"
import script from "./DesktopRemote.vue?vue&type=script&lang=js&"
export * from "./DesktopRemote.vue?vue&type=script&lang=js&"
import style0 from "./DesktopRemote.vue?vue&type=style&index=0&id=1f73663c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f73663c",
  null
  
)

export default component.exports